const toOrdering = (x: number): Ordering => {
  if (x < 0) {
    return -1
  }
  if (x > 0) {
    return 1
  }
  return 0
}

const orderNullalbe = (a: unknown, b: unknown) => {
  const rankA = a === null ? 1 : a === undefined ? 2 : 0
  const rankB = b === null ? 1 : b === undefined ? 2 : 0
  return toOrdering(rankA - rankB)
}

export const compareFunction = (a: unknown, b: unknown): Ordering => {
  if (typeof a === 'number' && typeof b === 'number') {
    return toOrdering(a - b)
  }
  if (typeof a === 'string' && typeof b === 'string') {
    return toOrdering(a.localeCompare(b))
  }
  if (a === undefined || b === undefined || a === null || b === null) {
    return orderNullalbe(a, b)
  }

  return toOrdering(JSON.stringify(a).localeCompare(JSON.stringify(b)))
}

export function isSome<T>(x: T): x is Exclude<T, undefined | null> {
  return x !== undefined && x !== null
}

export function isNull(x: unknown): x is undefined | null {
  return !isSome(x)
}

export function isPresent<T>(x: T): x is Exclude<T, undefined | null> {
  if (isNull(x)) {
    return false
  }
  if (typeof x === 'string') {
    return x !== ''
  }
  if (Array.isArray(x)) {
    return x.length > 0
  }

  return true
}

type Ordering = -1 | 0 | 1

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export function parseJsonIfValid(x: string): unknown | undefined {
  try {
    return JSON.parse(x) as unknown
  } catch (_e) {
    return undefined
  }
}
